import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["from", "children"];
import * as React from 'react';
import useTranslator from './useTranslator';
export default function FromNow(props) {
  var from = props.from,
    children = props.children,
    extraProps = _objectWithoutProperties(props, _excluded);
  var _useTranslator = useTranslator(),
    formatDate = _useTranslator.formatDate,
    localize = _useTranslator.localize;
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement("time", _extends({
      dateTime: formatDate(children, ''),
      title: formatDate(children, 'LLLL z')
    }, extraProps), localize(children).from(from || Date.now()))
  );
}